// extracted by mini-css-extract-plugin
module.exports = {"notFound":"style_notFound__3fWx5","notFoundText":"style_notFoundText__K28F0"};